<template>
  <div class="container-fluid">
        <div class="row centro justify-content-center">
            <div class="col-md-6 align-self-center">
                <div class="form-box mx-auto">
                    <img src="../assets/logo.png" alt="Editora do Brasil" class="img-fluid mx-auto d-block">
                    <form id="modifForm" @submit.prevent="modificar">
                        <div class="form-group">
                            <label for="modifPass1" class="label">Senha</label>
                            <div class="input-group">
                                <input id="modifPass1" type="password" v-model="$v.modif.Senha.$model" class="form-control" maxlength="250">
                            </div>
                            <p v-if="modifErrors" class="error">
                                <span v-if="!$v.modif.Senha.required">Preencha este campo, por favor. </span>
                                <span v-if="!$v.modif.Senha.strongPassword">Sua senha precisa ter uma letra, um número, um caractere especial e ter mais de 8 caracteres.</span>
                            </p>
                        </div>
                        <div class="form-group">
                            <label for="modifPass2" class="label">Confirmar senha</label>
                            <div class="input-group">
                                <input id="modifPass2" type="password" v-model="$v.modif.ConfirmarSenha.$model" class="form-control" maxlength="250">
                            </div>
                            <p v-if="modifErrors" class="error">
                                <span v-if="!$v.modif.ConfirmarSenha.required">Preencha este campo, por favor. </span>
                                <span v-if="!$v.modif.ConfirmarSenha.sameAsPassword">As senhas são diferentes.</span>
                            </p>
                        </div>
                        <div class="form-group">
                            <div id="modifMsg" class="alert alert-success fade show" role="alert">
                                Senha alterada com sucesso. Você será redirecionado a página inicial.
                            </div>
                            <div v-if="formTouched && uiState === 'submit clicked'" class="alert alert-danger fade show" role="alert">
                                Preencha todos os campos.
                            </div>
                        </div>
                        <div class="form-group">
                            <button @click.prevent="modificar" class="btn btn-recuperar btn-block">Atualizar senha</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {http} from '../services/APIservice'
import { required, sameAs } from 'vuelidate/lib/validators'

export default {
    name: 'recuperar-senha',
    data() {
        return {
            //Sets de Validação
            uiState: "submit not clicked",
            modifErrors: false,
            formTouched: false,
            empty: true,
            //Form
            modif: {
                Senha: null,
                ConfirmarSenha: null
            }
        }
    },
    //Validação de formulario
    validations: {
        modif: {
            Senha: {
                required,
                strongPassword(Senha) {
                    return (
                        /[a-z]/.test(Senha) && // checks for a-z
                        /[0-9]/.test(Senha) && // checks for 0-9
                        /\W|_/.test(Senha) && // checks for special char
                        Senha.length >= 8
                    );
                }
            },
            ConfirmarSenha: {
                required,
                sameAsPassword: sameAs("Senha")
            }
        }
    },
    methods: {
        modificar() {
            if (this.modif.ConfirmarSenha === null) {
                this.modifErrors = true
            }

            if (this.formTouched && this.uiState === 'submit clicked') {
                this.modifErrors = true
                //console.log(this.modifErrors);
            }

            this.formTouched = !this.$v.modif.$anyDirty;
            this.modifErrors = this.$v.modif.$anyError;
            this.uiState = "submit clicked";
            //console.log(this.uiState);

            if (this.modifErrors === false && this.formTouched === false) {
                //this is where you send the responses
                this.uiState = "form submitted";

                const email = this.$route.query.email
                const guid = this.$route.query.guid

                return http.get(`Usuario/RecuperarSenha?email=${email}&guid=${guid}&password=${this.modif.Senha}`).then(response => {
                //console.log(response.status)

                    if (response.status == 200) {
                        document.getElementById('modifMsg').style.display = 'block';
                        setTimeout(() => {
                            var url = window.location.origin;
                            window.location.href = url;
                        }, 5000);
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            }

            // console.log(email)
            // console.log(guid)
        }
    }
}
</script>
